module.exports = __webpack_public_path__ + "static/img/nav_pic2.6dc1feb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/nav_pic2.jpg
// module id = W1OV
// module chunks = 37